var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Poster2026 extends Component {
    constructor() {
        super('Poster', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.poster-2026').length > 0) {
                setTimeout(() => {
                    this.runAnimation();
                    setInterval(() => {
                        this.runAnimation();
                    }, 5000);
                }, 2000);
            }
            this.success();
        });
    }
    runAnimation() {
        $('.poster-text-title, .poster-text-dates, .poster-stripes-1, .poster-stripes-2').addClass('disappear');
        setTimeout(() => {
            $('.poster-text-title, .poster-text-dates, .poster-stripes-1, .poster-stripes-2').removeClass('disappear').addClass('appear');
        }, 2500);
    }
}
